// extracted by mini-css-extract-plugin
export default {"actions":"notesTable_actions__DIEvO"};